import { render, staticRenderFns } from "./pi-wx-qrcode.vue?vue&type=template&id=7beb213f&scoped=true&"
import script from "./pi-wx-qrcode.vue?vue&type=script&lang=js&"
export * from "./pi-wx-qrcode.vue?vue&type=script&lang=js&"
import style0 from "./pi-wx-qrcode.vue?vue&type=style&index=0&id=7beb213f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beb213f",
  null
  
)

export default component.exports